// extracted by mini-css-extract-plugin
export default {"input":"full-name-setting_input__dGqJ5"};